<template>
  <base-modal
    :id="modalId"
    :ok-handler="okHandler"
    :title="title"
    :ok-button-text="okButtonText"
    :ok-button-class="okButtonClass"
  >
    <div>
      Are you sure you want to {{ userNewState }} user <strong>{{ userName }}</strong>? 
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';

export default {
  name: 'DisableUserConfirmationModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: 'Update User',
    },
    content: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    okButtonClass: {
      type: String,
      default: 'btn-warning',
    }
  },
  data() {
    return {
      modalId: 'disable-user-confirmation-modal',
    }
  },
  computed: {
    userToUpdate: function()  {
      return this.$store.getters.getUserToUpdate;
    },
    userName: function() {
      let user = this.userToUpdate;
      if (user) {
        if (user.name) { return user.name; }
      }
      return '';
    },
    userNewState: function() {
      let user = this.userToUpdate;
      if (user) {
        if (!user.isEnabled) {
          return ' enable '
        }
      }
      return ' disable ';
    }
  },
  methods: {
    okHandler: function() {
      const user = {
        user: this.userToUpdate,
        isEnabled: !this.userToUpdate.isEnabled
      };
      const payload = {
        vm: this,
        user,
      };
      this.$store.dispatch('updateUser', payload);
    },
  },
}
</script>
